module.exports = __webpack_public_path__ + "components/page-header/static/icon-search-678d6f900fb576a72b6f920a2f0b6060.svg";